const jwtServiceConfig = {
  signIn: `${process.env.REACT_APP_API_BASE_URL}/api/auth/signin`,
  signUp: 'api/auth/sign-up',
  accessToken: `${process.env.REACT_APP_API_BASE_URL}/api/auth/createtoken`,
  updateUser: 'api/auth/user/update',
};

export default jwtServiceConfig;